module.exports = __webpack_public_path__ + "static/media/snm.fb919db4.svg";